import { operations } from "./openapi/generated-types";
import {
  createCompetition,
  createCompetitionGroup,
  createCompetitionMatchday,
  createPlayer,
  createTeam,
  enrollTeam,
  listGamesByCompetition,
  livestreamRegieReady,
  planGame,
} from "./openapi/api-client";
import { v4 as uuid } from "uuid";
import { DateTime } from "luxon";
import { players } from "./gsc-2026-players.ts";
//import sleep from "sleep-promise";

type CreateTeam =
  operations["team.write.create"]["requestBody"]["content"]["application/json"];
type CreateTurnier =
  operations["competition.write.create"]["requestBody"]["content"]["application/json"];
type CreateMatchday =
  operations["competition.write.create-matchday"]["requestBody"]["content"]["application/json"];
type CreateGroup =
  operations["competition.write.create-group"]["requestBody"]["content"]["application/json"];
type PlanGame =
  operations["game.write.plan"]["requestBody"]["content"]["application/json"];

export const setupGSC2026 = async () => {
  // turnier
  const fwc: CreateTurnier = {
    id: "f091369b-87d5-4b5b-b287-42b2ad689d3e",
    name: "GirlsSnowCup 2026",
    start: DateTime.fromISO("2026-01-24").toISO(),
    end: DateTime.fromISO("2026-01-25").toISO(),
    location: "Merkur-Arena Lübbecke",
    logoUrl:
      "https://app.girlssnowcup.de/app-assets/competitionlogo/girlssnowcup-rot.svg",
    settings: {
      topscorerCountAssists: false,
    },
  };
  await createCompetition(fwc);

  // teams
  const fwcTeams: Record<
    | "gsc" // girls snow cup
    | "wob" // vfl wolfsburg
    | "koe" // 1. fc köln
    | "fcu" // 1. fc union berlin
    | "bmg" // borussia mönchengladbach
    | "svw" // sv werder bremen
    | "hsv" // hamburger sv
    | "rbl" // rb leipzig
    | "b04" // bayer leverkusen
    | "sge" // frankfurt
    | "tsg" // hoffenheim
    | "pot" // turbine potsdam
    | "sgs" // sgs essen
    | "fcc" // carl zeiss jena
    | "fsv" // fsv gütersloh
    | "scf", // sc freiburg
    CreateTeam
  > = {
    gsc: {
      id: "7cf084a0-ca7d-4225-b8f7-5e474325b9ae",
      name: "GirlsSnowCup Auswahl",
      mediumName: "GirlsSnowCup",
      shortName: "GSC",
      primaryColor: "#aa0000",
      logoFilePath: "https://app.girlssnowcup.de/app-assets/teamlogo/gsc.png",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/gsc.jpg",
        description: "",
      },
    },
    rbl: {
      id: "978b4bf7-5990-4a2a-b800-d47cbfc0aa46",
      name: "RB Leipzig",
      shortName: "RBL",
      primaryColor: "#DD013F",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/rb-leipzig.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/rb-leipzig.jpg",
        description: "",
      },
    },
    koe: {
      id: "81cc3b17-3dbf-4105-a01f-094d97c956af",
      name: "1. FC Köln",
      mediumName: "Köln",
      shortName: "KOE",
      primaryColor: "#e20613",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/1-fc-koeln.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/1-fc-koeln.webp",
        description: "",
      },
    },
    svw: {
      id: "d851b9ae-26d5-4777-b215-4ab172d89023",
      name: "SV Werder Bremen",
      mediumName: "Werder Bremen",
      shortName: "SVW",
      primaryColor: "#1D9053",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/werder-bremen.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/sv-werder-bremen.jpg",
        description: "",
      },
    },
    b04: {
      id: "b080ae6a-2896-4f46-ac20-95903825673a",
      name: "Bayer 04 Leverkusen",
      mediumName: "Leverkusen",
      shortName: "B04",
      primaryColor: "#E32221",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/bayer-04-leverkusen.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/bayer-04-leverkusen.jpg",
        description: "",
      },
    },
    fcu: {
      id: "c804df87-2dc7-41e8-8d2e-aaa63035671a",
      name: "Union Berlin",
      shortName: "FCU",
      primaryColor: "#EB1923",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/1-fc-union-berlin.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/1-fc-union-berlin.jpg",
        description: "",
      },
    },
    hsv: {
      id: "89a9750f-38cd-4754-88f7-644eef4d51a2",
      name: "Hamburger SV",
      mediumName: "HSV",
      shortName: "HSV",
      primaryColor: "#0A3F86",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/hamburger-sv.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/hamburger-sv.jpg",
        description: "",
      },
    },
    bmg: {
      id: "5753eb9c-db47-4a0b-a4d3-5d0b98efabdf",
      name: "Borussia Mönchengladbach",
      mediumName: "M'gladbach",
      shortName: "BMG",
      primaryColor: "#000000",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/borussia-moenchengladbach.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/borussia-moenchengladbach.jpg",
        description: "",
      },
    },
    wob: {
      id: "b8dc7f36-7dc0-48fa-88ec-62ac1991d352",
      name: "VfL Wolfsburg",
      mediumName: "Wolfsburg",
      shortName: "WOB",
      primaryColor: "#41a639",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/vfl-wolfsburg.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/vfl-wolfsburg.jpg",
        description: "",
      },
    },
    sge: {
      id: "178098dc-0124-404b-9c7b-0ce4e1187419",
      name: "Eintracht Frankfurt",
      mediumName: "Frankfurt",
      shortName: "SGE",
      primaryColor: "#e30615",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/eintracht-frankfurt.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/eintracht-frankfurt.jpg",
        description: "",
      },
    },
    tsg: {
      id: "3ac3734f-7f4f-4d75-ac7f-73908dd00483",
      name: "TSG 1899 Hoffenheim",
      mediumName: "Hoffenheim",
      shortName: "TSG",
      primaryColor: "#1961b5",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/tsg-1899-hoffenheim.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/tsg-1899-hoffenheim.jpg",
        description: "",
      },
    },
    pot: {
      id: "b715434f-5168-4ad7-928f-ccf0b93f6ae7",
      name: "1. FFC Turbine Potsdam",
      mediumName: "Potsdam",
      shortName: "POT",
      primaryColor: "#173885",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/1-ffc-turbine-potsdam.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/1-ffc-turbine-potsdam.jpg",
        description: "",
      },
    },
    sgs: {
      id: "fa0f8a1d-d7e5-4f55-bcb7-4819d88872c3",
      name: "SGS Essen",
      shortName: "SGS",
      primaryColor: "#572381",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/sgs-essen.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/sgs-essen.jpg",
        description: "",
      },
    },
    fcc: {
      id: "cba33177-d7ef-416c-868b-2ed617f4b525",
      name: "FC Carl Zeiss Jena",
      mediumName: "Carl Zeiss Jena",
      shortName: "FCC",
      primaryColor: "#053183",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/fc-carl-zeiss-jena.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/fc-carl-zeiss-jena.jpg",
        description: "",
      },
    },
    fsv: {
      id: "6f0a8243-395a-4165-8c46-4a50fe5296c6",
      name: "FSV Gütersloh 2009",
      mediumName: "Gütersloh",
      shortName: "FSV",
      primaryColor: "#B61918",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/fsv-guetersloh-2009.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/fsv-guetersloh-2009.jpg",
        description: "",
      },
    },
    scf: {
      id: "f382802a-0408-4f3e-92f8-ef15d6ffb3ad",
      name: "SC Freiburg",
      mediumName: "Freiburg",
      shortName: "SCF",
      primaryColor: "#ffffff",
      logoFilePath:
        "https://app.girlssnowcup.de/app-assets/teamlogo/sc-freiburg.svg",
      photo: {
        filePath:
          "https://app.girlssnowcup.de/app-assets/teamphoto/2026/gsc/sc-freiburg.jpg",
        description: "",
      },
    },
  };

  const createTeams = Object.values(fwcTeams).map(async (t) => {
    await createTeam(t);
    await enrollTeam({
      id: fwc.id,
      teamId: t.id,
    });
  });
  await Promise.all(createTeams);

  // groups
  const gruppeA: CreateGroup = {
    id: fwc.id,
    groupId: "8400fb1b-5a7e-461a-8e10-b8d036889458",
    name: "Gruppe A",
    teamIds: [fwcTeams.tsg, fwcTeams.hsv, fwcTeams.bmg, fwcTeams.fcc].map(
      (t) => t.id,
    ),
  };
  const gruppeB: CreateGroup = {
    id: fwc.id,
    groupId: "781fdffa-38df-4820-8e22-de48352e8b88",
    name: "Gruppe B",
    teamIds: [fwcTeams.pot, fwcTeams.fcu, fwcTeams.sge, fwcTeams.rbl].map(
      (t) => t.id,
    ),
  };
  const gruppeC: CreateGroup = {
    id: fwc.id,
    groupId: "1610d6ca-d334-43ca-95b4-a58a1fb47d4d",
    name: "Gruppe C",
    teamIds: [fwcTeams.sgs, fwcTeams.koe, fwcTeams.scf, fwcTeams.fsv].map(
      (t) => t.id,
    ),
  };
  const gruppeD: CreateGroup = {
    id: fwc.id,
    groupId: "65e652ea-d224-49ab-b754-a1fbc88cd248",
    name: "Gruppe D",
    teamIds: [fwcTeams.gsc, fwcTeams.svw, fwcTeams.b04, fwcTeams.wob].map(
      (t) => t.id,
    ),
  };

  await createCompetitionGroup(gruppeA);
  await createCompetitionGroup(gruppeB);
  await createCompetitionGroup(gruppeC);
  await createCompetitionGroup(gruppeD);

  // die nächsten gruppen sind dynamisch
  // 1a, 2b, 1c, 2d | 2a, 1b, 2c, 1d | 3a, 4b, 3c, 4d | 4a, 3b, 4c, 3d
  const gruppe1: CreateGroup = {
    id: fwc.id,
    groupId: "338e9385-ef1f-4dec-a166-88c4938fbecb",
    name: "Gruppe 1",
    teamIds: [],
    slots: [
      { position: 1, groupId: gruppeA.groupId },
      { position: 2, groupId: gruppeB.groupId },
      { position: 1, groupId: gruppeC.groupId },
      { position: 2, groupId: gruppeD.groupId },
    ],
  };
  const gruppe2: CreateGroup = {
    id: fwc.id,
    groupId: "515ae762-7b92-434f-a665-417c0036a4d3",
    name: "Gruppe 2",
    teamIds: [],
    slots: [
      { position: 2, groupId: gruppeA.groupId },
      { position: 1, groupId: gruppeB.groupId },
      { position: 2, groupId: gruppeC.groupId },
      { position: 1, groupId: gruppeD.groupId },
    ],
  };
  const gruppe3: CreateGroup = {
    id: fwc.id,
    groupId: "c7513739-b98e-4ae5-ad65-584d4a6ac838",
    name: "Gruppe 3",
    teamIds: [],
    slots: [
      { position: 3, groupId: gruppeA.groupId },
      { position: 4, groupId: gruppeB.groupId },
      { position: 3, groupId: gruppeC.groupId },
      { position: 4, groupId: gruppeD.groupId },
    ],
  };
  const gruppe4: CreateGroup = {
    id: fwc.id,
    groupId: "681602ab-42a1-428b-82d4-7cc6c3fe548d",
    name: "Gruppe 4",
    teamIds: [],
    slots: [
      { position: 4, groupId: gruppeA.groupId },
      { position: 3, groupId: gruppeB.groupId },
      { position: 4, groupId: gruppeC.groupId },
      { position: 3, groupId: gruppeD.groupId },
    ],
  };

  await createCompetitionGroup(gruppe1);
  await createCompetitionGroup(gruppe2);
  await createCompetitionGroup(gruppe3);
  await createCompetitionGroup(gruppe4);

  // matchdays
  const matchdays: Record<
    | "vorrunde"
    | "zwischenrunde"
    | "platz-15-16"
    | "platz-13-14"
    | "platz-11-12"
    | "platz-9-10"
    | "halbfinale"
    | "platz-7-8"
    | "platz-5-6"
    | "platz-3-4"
    | "endspiel",
    CreateMatchday
  > = {
    vorrunde: {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Vorrunde",
    },
    zwischenrunde: {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Zwischenrunde",
    },
    "platz-15-16": {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Spiel um Platz 15 und 16",
    },
    "platz-13-14": {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Spiel um Platz 13 und 14",
    },
    "platz-11-12": {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Spiel um Platz 11 und 12",
    },
    "platz-9-10": {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Spiel um Platz 9 und 10",
    },
    halbfinale: {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Halbfinale",
    },
    "platz-7-8": {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Spiel um Platz 7 und 8",
    },
    "platz-5-6": {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Spiel um Platz 5 und 6",
    },
    "platz-3-4": {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Spiel um Platz 3 und 4",
    },
    endspiel: {
      id: fwc.id,
      matchdayId: uuid(),
      name: "Endspiel",
    },
  };

  await createCompetitionMatchday(matchdays.vorrunde);
  await createCompetitionMatchday(matchdays.zwischenrunde);
  await createCompetitionMatchday(matchdays["platz-15-16"]);
  await createCompetitionMatchday(matchdays["platz-13-14"]);
  await createCompetitionMatchday(matchdays["platz-11-12"]);
  await createCompetitionMatchday(matchdays["platz-9-10"]);
  await createCompetitionMatchday(matchdays.halbfinale);
  await createCompetitionMatchday(matchdays["platz-7-8"]);
  await createCompetitionMatchday(matchdays["platz-5-6"]);
  await createCompetitionMatchday(matchdays["platz-3-4"]);
  await createCompetitionMatchday(matchdays.endspiel);

  // games
  const gamesVorrunde: PlanGame[] = [
    {
      id: uuid(),
      groupId: gruppeA.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 01",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.tsg.id,
        },
        guest: {
          teamId: fwcTeams.bmg.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T10:00:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeA.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 02",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.fcc.id,
        },
        guest: {
          teamId: fwcTeams.hsv.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T10:17:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeB.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 03",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.pot.id,
        },
        guest: {
          teamId: fwcTeams.sge.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T10:34:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeB.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 04",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.rbl.id,
        },
        guest: {
          teamId: fwcTeams.fcu.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T10:51:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeC.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 05",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.sgs.id,
        },
        guest: {
          teamId: fwcTeams.koe.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T11:08:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeC.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 06",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.scf.id,
        },
        guest: {
          teamId: fwcTeams.fsv.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T11:25:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeD.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 07",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.gsc.id,
        },
        guest: {
          teamId: fwcTeams.wob.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T11:42:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeD.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 08",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.b04.id,
        },
        guest: {
          teamId: fwcTeams.svw.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T11:59:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeA.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 09",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.hsv.id,
        },
        guest: {
          teamId: fwcTeams.tsg.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T12:16:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeA.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 10",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.bmg.id,
        },
        guest: {
          teamId: fwcTeams.fcc.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T12:33:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeB.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 11",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.fcu.id,
        },
        guest: {
          teamId: fwcTeams.pot.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T12:50:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeB.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 12",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.sge.id,
        },
        guest: {
          teamId: fwcTeams.rbl.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T13:07:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeC.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 13",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.fsv.id,
        },
        guest: {
          teamId: fwcTeams.sgs.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T13:34:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeC.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 14",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.koe.id,
        },
        guest: {
          teamId: fwcTeams.scf.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T13:51:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeD.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 15",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.svw.id,
        },
        guest: {
          teamId: fwcTeams.gsc.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T14:08:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeD.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 16",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.wob.id,
        },
        guest: {
          teamId: fwcTeams.b04.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T14:25:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeA.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 17",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.tsg.id,
        },
        guest: {
          teamId: fwcTeams.fcc.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T14:42:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeA.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 18",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.bmg.id,
        },
        guest: {
          teamId: fwcTeams.hsv.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T14:59:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeB.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 19",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.pot.id,
        },
        guest: {
          teamId: fwcTeams.rbl.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T15:16:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeB.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 20",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.sge.id,
        },
        guest: {
          teamId: fwcTeams.fcu.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T15:33:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeC.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 21",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.sgs.id,
        },
        guest: {
          teamId: fwcTeams.scf.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T15:50:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeC.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 22",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.koe.id,
        },
        guest: {
          teamId: fwcTeams.fsv.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T16:07:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeD.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 23",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.gsc.id,
        },
        guest: {
          teamId: fwcTeams.b04.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T16:24:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppeD.groupId,
      matchdayId: matchdays.vorrunde.matchdayId,
      name: "Spiel 24",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          teamId: fwcTeams.wob.id,
        },
        guest: {
          teamId: fwcTeams.svw.id,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T16:41:00").toISO(),
    },
  ];

  const createGamesVorrunde = gamesVorrunde.map((g) => planGame(g));
  await Promise.all(createGamesVorrunde);

  const gamesZwischenrunde: PlanGame[] = [
    {
      id: uuid(),
      groupId: gruppe4.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 25",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppeB.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T17:05:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe4.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 26",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeC.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T17:22:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe3.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 27",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppeB.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T17:39:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe3.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 28",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeC.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T17:56:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe2.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 29",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 2,
        },
        guest: {
          groupId: gruppeB.groupId,
          position: 1,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T18:13:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe2.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 30",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeC.groupId,
          position: 2,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 1,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T18:30:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe1.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 31",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 1,
        },
        guest: {
          groupId: gruppeB.groupId,
          position: 2,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T18:47:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe1.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 32",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeC.groupId,
          position: 1,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 2,
        },
      },
      dateTime: DateTime.fromISO("2026-01-24T19:04:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe4.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 33",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeD.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppeA.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T08:30:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe4.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 34",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T08:47:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe3.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 35",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeD.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppeA.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T09:04:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe3.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 36",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T09:21:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe2.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 37",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeD.groupId,
          position: 1,
        },
        guest: {
          groupId: gruppeA.groupId,
          position: 2,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T09:38:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe2.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 38",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 1,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 2,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T09:55:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe1.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 39",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeD.groupId,
          position: 2,
        },
        guest: {
          groupId: gruppeA.groupId,
          position: 1,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T10:12:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe1.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 40",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 2,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 1,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T10:29:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe4.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 41",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T10:46:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe4.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 42",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T11:03:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe3.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 43",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T11:20:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe3.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 44",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T11:37:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe2.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 45",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 2,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 2,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T11:54:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe2.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 46",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 1,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 1,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T12:11:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe1.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 47",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeA.groupId,
          position: 1,
        },
        guest: {
          groupId: gruppeC.groupId,
          position: 1,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T12:28:00").toISO(),
    },
    {
      id: uuid(),
      groupId: gruppe1.groupId,
      matchdayId: matchdays.zwischenrunde.matchdayId,
      name: "Spiel 48",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppeB.groupId,
          position: 2,
        },
        guest: {
          groupId: gruppeD.groupId,
          position: 2,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T12:45:00").toISO(),
    },
  ];

  const createGamesZwischenrunde = gamesZwischenrunde.map((g) => planGame(g));
  await Promise.all(createGamesZwischenrunde);

  const gamesPlatzierungsspiele: PlanGame[] = [
    {
      id: uuid(),
      matchdayId: matchdays["platz-15-16"].matchdayId,
      name: "Spiel 49",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppe3.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppe4.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T13:30:00").toISO(),
    },
    {
      id: uuid(),
      matchdayId: matchdays["platz-13-14"].matchdayId,
      name: "Spiel 50",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppe3.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppe4.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T13:47:00").toISO(),
    },
    {
      id: uuid(),
      matchdayId: matchdays["platz-11-12"].matchdayId,
      name: "Spiel 51",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppe3.groupId,
          position: 2,
        },
        guest: {
          groupId: gruppe4.groupId,
          position: 2,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T14:04:00").toISO(),
    },
    {
      id: uuid(),
      matchdayId: matchdays["platz-9-10"].matchdayId,
      name: "Spiel 52",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppe3.groupId,
          position: 1,
        },
        guest: {
          groupId: gruppe4.groupId,
          position: 1,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T14:21:00").toISO(),
    },
    {
      id: uuid(),
      matchdayId: matchdays["platz-7-8"].matchdayId,
      name: "Spiel 55",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppe1.groupId,
          position: 4,
        },
        guest: {
          groupId: gruppe2.groupId,
          position: 4,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T15:12:00").toISO(),
    },
    {
      id: uuid(),
      matchdayId: matchdays["platz-5-6"].matchdayId,
      name: "Spiel 56",
      competitionId: fwc.id,
      duration: 13 * 60,
      plannedTeams: {
        home: {
          groupId: gruppe1.groupId,
          position: 3,
        },
        guest: {
          groupId: gruppe2.groupId,
          position: 3,
        },
      },
      dateTime: DateTime.fromISO("2026-01-25T15:29:00").toISO(),
    },
  ];

  const createGamesPlatzierungsspiele = gamesPlatzierungsspiele.map((g) =>
    planGame(g),
  );
  await Promise.all(createGamesPlatzierungsspiele);

  const halbfinale1: PlanGame = {
    id: uuid(),
    matchdayId: matchdays.halbfinale.matchdayId,
    name: "Spiel 53",
    competitionId: fwc.id,
    duration: 13 * 60,
    plannedTeams: {
      home: {
        groupId: gruppe1.groupId,
        position: 1,
      },
      guest: {
        groupId: gruppe2.groupId,
        position: 2,
      },
    },
    dateTime: DateTime.fromISO("2026-01-25T14:38:00").toISO(),
  };
  const halbfinale2: PlanGame = {
    id: uuid(),
    matchdayId: matchdays.halbfinale.matchdayId,
    name: "Spiel 54",
    competitionId: fwc.id,
    duration: 13 * 60,
    plannedTeams: {
      home: {
        groupId: gruppe1.groupId,
        position: 2,
      },
      guest: {
        groupId: gruppe2.groupId,
        position: 1,
      },
    },
    dateTime: DateTime.fromISO("2026-01-25T14:55:00").toISO(),
  };
  const spiel_platz_3_4: PlanGame = {
    id: uuid(),
    matchdayId: matchdays["platz-3-4"].matchdayId,
    name: "Spiel 57",
    competitionId: fwc.id,
    duration: 13 * 60,
    plannedTeams: {
      home: {
        loserTeam: halbfinale1.id,
      },
      guest: {
        loserTeam: halbfinale2.id,
      },
    },
    dateTime: DateTime.fromISO("2026-01-25T15:56:00").toISO(),
  };
  const endspiel: PlanGame = {
    id: uuid(),
    matchdayId: matchdays.endspiel.matchdayId,
    name: "Spiel 58",
    competitionId: fwc.id,
    duration: 13 * 60,
    plannedTeams: {
      home: {
        winnerTeam: halbfinale1.id,
      },
      guest: {
        winnerTeam: halbfinale2.id,
      },
    },
    dateTime: DateTime.fromISO("2026-01-25T16:13:00").toISO(),
  };

  const createFinalGames = [
    halbfinale1,
    halbfinale2,
    spiel_platz_3_4,
    endspiel,
  ].map((g) => planGame(g));
  await Promise.all(createFinalGames);

  // players
  const createAllPlayers = players.map((p) => {
    return createPlayer({
      id: uuid(),
      firstName: p.firstName,
      lastName: p.lastName,
      isGoalkeeper: p.isGoalkeeper,
      number: p.number,
      teamId: fwcTeams[p.teamShortName]?.id ?? "",
      birthday: `${p.birthday}T00:00:00+01:00`,
    });
  });

  await Promise.all(createAllPlayers);

  // get all games and set regie ready
  const allGames = await listGamesByCompetition({ competitionId: fwc.id });
  const setRegieReadyPromises = allGames.data.games.map((game) =>
    livestreamRegieReady({ id: game.id }),
  );
  await Promise.all(setRegieReadyPromises);
};
